import { ModalBody } from '@/common-utils/components/ui/modal';
import './BodyNews.scss';
import PropTypes from 'prop-types';

const BodyNews = ({ setDisableValidateButton, children }) => {
    const checkScrollIsDown = (event) => {
        const isBottomReached = event.target.scrollHeight - Math.round(event.target.scrollTop) - 40 <= event.target.clientHeight;

        if (isBottomReached) {
            setDisableValidateButton(false);
        }
        else {
            setDisableValidateButton(true);
        }
    };

    return (
        <ModalBody onScroll={checkScrollIsDown} className='modal-news'>
            {children}
        </ModalBody>
    );
};

BodyNews.propTypes = {
    setDisableValidateButton: PropTypes.func.isRequired,
    children: PropTypes.element.isRequired
};

export default BodyNews;